
import { useState, useEffect } from 'react';

export default function ScrollButtons() {
  const [showButtons, setShowButtons] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      
      // Show buttons when user has scrolled more than 200px
      setShowButtons(scrollTop > 200);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const scrollToBottom = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: 'smooth'
    });
  };

  if (!showButtons) return null;

  return (
    <div className="fixed right-6 bottom-6 z-50 flex flex-col space-y-2">
      {/* Scroll to Top Button */}
      <button
        onClick={scrollToTop}
        className="w-12 h-12 bg-blue-600 hover:bg-blue-700 text-white rounded-full shadow-lg transition-all duration-300 flex items-center justify-center cursor-pointer group"
        aria-label="Scroll to top"
      >
        <i className="ri-arrow-up-line text-xl group-hover:scale-110 transition-transform"></i>
      </button>
      
      {/* Scroll to Bottom Button */}
      <button
        onClick={scrollToBottom}
        className="w-12 h-12 bg-gray-600 hover:bg-gray-700 text-white rounded-full shadow-lg transition-all duration-300 flex items-center justify-center cursor-pointer group"
        aria-label="Scroll to bottom"
      >
        <i className="ri-arrow-down-line text-xl group-hover:scale-110 transition-transform"></i>
      </button>
    </div>
  );
}
